"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionCheckbox = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./OptionCheckbox.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var OptionCheckbox = function (_a) {
    var item = _a.item, isDisabled = _a.isDisabled, isSelected = _a.isSelected, onChange = _a.onChange, explainer = _a.explainer, disabledReason = _a.disabledReason;
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                if (isDisabled && disabledReason) {
                    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: disabledReason, size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true }, children));
                }
            } },
            react_1.default.createElement(kaleidoscope_1.Checkbox, { item: item, isDisabled: isDisabled, isSelected: isSelected, onChange: onChange })),
        explainer && (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                explainer.heading && (react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true, theme: "dark" }, explainer.heading)),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", theme: "dark" }, explainer.content)), size: kaleidoscope_1.TooltipSize.Large },
            react_1.default.createElement(icons_1.Help, { size: icons_1.IconSize.Small, color: "default" })))));
};
exports.OptionCheckbox = OptionCheckbox;
